module.exports = __webpack_public_path__ + "static/media/illustration-palette.41fe6ff8.png";